// @flow
import { createSelector } from 'reselect';
import compose from 'recompose/compose';
import prop from 'ramda/es/prop';
import pipe from 'ramda/es/pipe';
import has from 'ramda/es/has';
import map from 'ramda/es/map';

import mapPropsCreate from 'app/common/containers/mapPropsCreate';
import { objToArrayArangedBy } from 'app/common/lib/object';

import informsDefault from '../informsDefault';


const createInformsSelector = () => createSelector(
  [
    prop('tariff'),
    prop('over'),
    prop('arrange'),
  ],
  (tariff, over = {}, arrange) => pipe(
    map((informer) => {
      const { id: informName } = informer;
      const informerEnabled = (has(informName, over)
        ? over[informName]
        : prop(`${informName}_provided`, tariff));
      const informerChecked = prop(`${informName}_enabled`, tariff);

      return ({
        ...informer,
        enabled: informerEnabled,
        checked: informerChecked,
      });
    }),
    objToArrayArangedBy(arrange || ['lk', 'mobile', 'sms', 'email'])
  )(informsDefault())
);

export default compose(
  mapPropsCreate(() => {
    const selectInforms = createInformsSelector();

    return props => ({
      ...props,
      informs: selectInforms(props),
    });
  })
);
